const lang = {
    ja: {
        'settingSellProductOrganizer.pageTitle': '商品販売設定',
    },
};

export default lang;
